export default "__VITE_ASSET__03adfca9__"